<template>
  <div>
    <div class="tway-headline-2 tway-morado--text text-center">
      Socios estratégicos y alianzas
    </div>
    <v-row class="mt-5" justify="center">
      <v-col cols="2" class="mt-n2">
        <a href="https://www.liderbciserviciosfinancieros.cl" target="_blank">
          <v-img
            :src="require('@/assets/images/partners/logo-ssff.png')"
            contain
            max-height="170"
            max-width="170"
            class=""
          />
        </a>
      </v-col>
      <v-col cols="2">
        <a href="https://www.symbiose.cl/" target="_blank">
          <v-img
            :src="require('@/assets/images/partners/logo-symbiose-footer.svg')"
            max-width="160"
            contain
          />
        </a>
      </v-col>
      <v-col cols="2">
        <a href="http://redchtransformaciondigital.com/" target="_blank">
          <v-img
            :src="require('@/assets/images/partners/logo-red-footer.png')"
            max-width="160"
            contain
          />
        </a>
      </v-col>
      <v-col cols="2">
        <a href="https://www.getabstract.com/es/" target="_blank">
          <v-img
            :src="
              require('@/assets/images/partners/logo-getabstract-footer.png')
            "
            max-width="160"
            contain
          />
        </a>
      </v-col>
      <v-col cols="2">
        <a href="https://www.openbeauchef.cl/" target="_blank">
          <v-img
            :src="
              require('@/assets/images/partners/logo-open-beauchef-footer.png')
            "
            max-width="160"
            contain
          />
        </a>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="2">
        <a href="https://www.recreotech.com/" target="_blank">
          <v-img
            :src="
              require('@/assets/images/partners/logo-recreotech-footer.png')
            "
            max-width="160"
            contain
          />
        </a>
      </v-col>
      <v-col cols="2">
        <a href="http://www.innmetrics.cl/" target="_blank">
          <v-img
            :src="require('@/assets/images/partners/logo-inmetrics-footer.png')"
            max-width="160"
            contain
          />
        </a>
      </v-col>
      <v-col cols="1">
        <a href="https://www.chileconverge.cl/" target="_blank">
          <v-img
            :src="require('@/assets/images/partners/logo-chile-converge.png')"
            max-width="80"
            contain
          />
        </a>
      </v-col>
      <v-col cols="2">
        <a href="https://www.sonda.com/" target="_blank">
          <v-img
            :src="require('@/assets/images/partners/logo-sonda-footer.png')"
            max-width="160"
            contain
          />
        </a>
      </v-col>
      <v-col cols="2">
        <a href="https://www.emprendetumente.org/" target="_blank" style="">
          <v-img
            :src="require('@/assets/images/partners/EtM.png')"
            max-width="190"
            style="margin-top: -25px; margin-left: -40px;"
          />
        </a>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  export default {
    name: "Partners",
  };
</script>
